import { getCommentMaxLengthError } from '@opportunities/-lib/opportunityValidation'

/**
 * コメント変更時の共通処理（値セット＋バリデーション）
 */
export function handleCommentChange(
  value: string,
  setValue: (value: string) => void,
  setError: (error: string | null) => void,
) {
  setValue(value)
  setError(getCommentMaxLengthError(value))
}
